module.exports = __webpack_public_path__ + "dist/introduce_5.87973d6c.png";